import clsx from 'clsx';
import emptyStateIllustration from '../../assets/images/templates-empty-state.svg';
import styles from './EmptyState.module.css';

export function EmptyState({ title, subtitle, ariaLabel, children }) {
  return (
    <section className={clsx(styles.empty)} aria-label={ariaLabel}>
      <img
        className={clsx(styles.illustration)}
        src={emptyStateIllustration}
        alt=""
        aria-hidden="true"
      />
      <div className={clsx(styles.text)}>
        <h2 className={clsx(styles.title)}>{title}</h2>
        <p className={clsx(styles.subtitle)}>{subtitle}</p>
      </div>
      {children}
    </section>
  );
}
